export default ({request}) => ({
  fabricStockOutListApi(data = {}) {
    return request({
      url: '/digitalCenter/fabricStockOut/list',
      method: 'post',
      data,
    })
  },
  fabricStockOutDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/fabricStockOut/detail',
      method: 'post',
      data,
    })
  },
  fabricStockOutSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/fabricStockOut/save',
      method: 'post',
      data,
    })
  },
  fabricStockOutdDelApi(data = {}) {
    return request({
      url: '/digitalCenter/fabricStockOut/del',
      method: 'post',
      data,
    })
  },
  fabricStockOutdAuditApi(data = {}) {
    return request({
      url: '/digitalCenter/fabricStockOut/audit',
      method: 'post',
      data,
    })
  },
  fabricStockOutUseMaxQuantityApi(data = {}) {
    return request({
      url: '/digitalCenter/fabricStockOut/useMaxQuantity',
      method: 'post',
      data,
    })
  },
  fabricStockOutDeliveryConfirmation(data = {}) {
    return request({
      url: '/digitalCenter/fabricStockOut/confirmation',
      method: 'post',
      data,
    })
  },
  fabricStockOutOaStockOutApply(data = {}) {
    return request({
      url: '/oa/fabric/stockOut/stockOutApply',
      method: 'post',
      data,
    })
  },
  fabricStockOutModifyStatusByCodeApi(data = {}) {
    return request({
      url: '/digitalCenter/fabricStockOut/modifyStatusByCode',
      method: 'post',
      data,
    })
  },
})
